import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnIntegrationType extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public appId: string;

  @Expose()
  public name: string;

  @Expose()
  public status: string;

  @Expose()
  public code: string;

  @Expose()
  public visible: boolean;

  @Expose()
  public isDefaultApp: boolean;

  @Expose()
  public isIntegrated: boolean;

  @Expose()
  public isRequested: boolean;

  @Expose()
  public isComingSoon: boolean;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
